import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ValidationAprovalRequest } from '../../../models/entity-validation.model';
import { Entity } from 'src/app/models/entities.model';
import * as moment from 'moment';
import { FormControl, Validators, FormBuilder } from '@angular/forms';

@Component({
  selector: 'gio-validation-confirmation',
  templateUrl: './validation-confirmation.component.html',
  styleUrls: ['./validation-confirmation.component.scss']
})
export class ValidationConfirmationComponent implements OnInit {

  message: string;

  started = false;
  form = this.fb.group({});

  constructor(
    private dialogRef: MatDialogRef<ValidationConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { entity: Entity, dataToSave: ValidationAprovalRequest },
    private fb: FormBuilder

  ) { }

  ngOnInit() {

    const obs: string[] = [];

    const documentsToReject = this.data.dataToSave.rejections.filter(_m => _m.type === 'D');
    if (documentsToReject && documentsToReject.length > 0) {
      obs.push(`<li>Os ${documentsToReject.length} documentos rejeitados serão <b>excluidos</b></li>`);
    }

    if (this.data.dataToSave.fieldsToUpdate && this.data.dataToSave.fieldsToUpdate.validation_expires) {
      const data = moment(this.data.dataToSave.fieldsToUpdate.validation_expires);
      obs.push(`<li>Esta validação irá expirar em: ${data.format('DD/MM/YYYY')}</li>`);
      this.form.addControl('message', new FormControl('', Validators.required));
    } else {
      this.form.addControl('message', new FormControl(''));
    }

    this.started = true;

    let extraInfo = '';
    if (obs.length > 0) {
      extraInfo = `<ul>${obs.join(' ')}</ul>`;
    }
    this.message = `Esta operação irá ${this.data.dataToSave.validationType === 'aprove' ? 'aprovar' : 'rejeitar'} o perfil de
      ${this.data.entity.name}!
      ${extraInfo}
    `;
  }

  cancel() {
    this.dialogRef.close();
  }

  confirm() {
    if (!this.form.valid) {
      return;
    }

    this.dialogRef.close({
      message: this.form.value.message
    });
  }
}
